module.exports = __webpack_public_path__ + "img/ep1-19.8ec3052d.jpg";